import { Controller } from '@hotwired/stimulus';

import I18n from '@/modules/i18n';
import Tip from '@/modules/tip';

export default class extends Controller {
  static targets = ['source'];

  static values = { text: String };

  async copy(event) {
    // menu-actions closes on any document click; without this, the async clipboard write lets the
    // menu hide first and Tip.flash anchors to a hidden element (tooltip jumps to the top-left).
    event.stopPropagation();

    const button = event.currentTarget;

    try {
      await navigator.clipboard.writeText(this.#text());
    } catch {
      return Tip.flash(button, I18n.t('fail.one'));
    }

    Tip.flash(button, I18n.t('copied'));
  }

  #text() {
    return this.hasTextValue ? this.textValue : this.sourceTarget.textContent.trim();
  }
}
